function createFormatPartIndices(format, formatMap) {
  let foundIndeces = [];
  formatMap.forEach(searchKeyInfo => {
    // eslint-disable-next-line
    let foundIndex = 0;
    let searchIndex = 0;
    while (foundIndex >= 0) {
      foundIndex = format.indexOf(searchKeyInfo.key, searchIndex);
      if (foundIndex >= 0) {
        foundIndeces.push({
          start: foundIndex,
          end: foundIndex + searchKeyInfo.key.length,
          length: searchKeyInfo.key.length,
          value: searchKeyInfo.value
        });
        searchIndex = foundIndex + searchKeyInfo.key.length;
      }
    }
  });
  // sort
  foundIndeces.sort((a, b) => {
    if (a.start == b.start) {
      return b.length - a.length;
    }
    return a.start - b.start;
  });
  // remove element with key which is part of other keys
  for (let i = foundIndeces.length - 1; i >= 0; i--) {
    for (let j = i - 1; j >= 0; j--) {
      if (foundIndeces[i].start >= foundIndeces[j].start && foundIndeces[i].end <= foundIndeces[j].end) {
        foundIndeces.splice(i, 1);
        break;
      }
    }
  }
  return foundIndeces;
}

function toLeadZeroText(number, length) {
  let text = number.toString();
  while (text.length < length) {
    text = "0" + text;
  }
  return text;
}

export function formatDate(dateTime, format) {
  // define order match
  let formatMap = [
    {
      key: "YYYY",
      value: toLeadZeroText(dateTime.getFullYear(), 4)
    },
    {
      key: "MM",
      value: toLeadZeroText(dateTime.getMonth() + 1, 2)
    },
    {
      key: "DD",
      value: toLeadZeroText(dateTime.getDate(), 2)
    },
    {
      key: "hh",
      value: toLeadZeroText(dateTime.getHours(), 2)
    },
    {
      key: "mm",
      value: toLeadZeroText(dateTime.getMinutes(), 2)
    },
    {
      key: "sss",
      value: toLeadZeroText(dateTime.getMilliseconds(), 3)
    },
    {
      key: "ss",
      value: toLeadZeroText(dateTime.getSeconds(), 2)
    }
  ];
  const formatParts = createFormatPartIndices(format, formatMap);
  let resultText = "";
  let selectStartIndex = 0;
  for (let i = 0; i < formatParts.length; i++) {
    const formatPart = formatParts[i];
    if (selectStartIndex != formatPart.start) {
      resultText += format.substring(selectStartIndex, formatPart.start);
    }
    resultText += formatPart.value;
    selectStartIndex = formatPart.end;
  }
  if (selectStartIndex < format.length) {
    resultText += format.substring(selectStartIndex);
  }
  return resultText;
}
